<div>
  <table class="tbl tbl--full tbl--hovered">
    <colgroup>
      <col width="145px" />
      <col />
      <col />
      <col width="80px" />
      <col width="75px" />
    </colgroup>
    <thead>
      <tr>
        <th>Дата</th>
        <th>Тип</th>
        <th>Контент</th>
        <th>Приоритет</th>
        <th>Действия</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let notification of notifications" [ngClass]="{ 'color-gray-dark': notification.status === 1 }">
        <td>
          {{ notification.create_date | dateFormat: 'DD.MM.YYYY HH:mm' }}
        </td>
        <td>
          <div
            class="label label--low"
            [ngClass]="{
              'label--low': notification.notification_type && notification.notification_type.priority === 1,
              'label--high': notification.notification_type && notification.notification_type.priority !== 1,
              'label--check': notification.status === 1
            }"
          >
            {{ notification.notification_type && notification.notification_type.name }}
          </div>
        </td>
        <td>
          <a
            class="link"
            *ngIf="notification.url_name !== null"
            [ngClass]="{
              'link--gray-dark': notification.status === 1
            }"
            [routerLink]="pagesMapService.makeRoutePath(notification.url_name, notification.positional_params, notification.query_params)"
          >
            {{ notification.text }}
          </a>
          <span *ngIf="notification.url_name === null">{{ notification.text }}</span>
        </td>
        <td>
          {{ notification.notification_type && notification.notification_type.priority }}
        </td>
        <td>
          <button
            [disabled]="notification.isChangeStatus"
            title="Пометить прочитанным"
            *ngIf="notification.status === 0"
            (click)="onChangeNotificationStatus(notification)"
            class="ctrl color-blue"
          >
            <app-icon [glyph]="'check'" [size]="'18'" [class]="'icon--va-middle'"></app-icon>
          </button>
          <button
            [disabled]="notification.isChangeStatus"
            title="Пометить непрочитанным"
            *ngIf="notification.status === 1"
            (click)="onChangeNotificationStatus(notification)"
            class="ctrl color-gray"
          >
            <app-icon [glyph]="'check'" [size]="'18'" [class]="'icon--va-middle'"></app-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="mt-32 pagination__block">
    <button
      type="button"
      class="button pagination__block-button"
      (click)="filter.onGetPartialData()"
      *ngIf="(notifications && notifications.length) < filter.paginationBlock.countsAllElements"
    >
      Показать еще {{ filter.paginationBlock.limitSelected }} записей
    </button>
    <div class="pagination__block-list">
      <div class="grid">
        <div class="grid__box grid__box--size-min">Показывать по:</div>
        <div class="grid__box grid__box--size-min" *ngFor="let count of filter.paginationBlock.limits">
          <span
            [ngClass]="{
              'link link--dotted-gray-dark': count !== filter.paginationBlock.limitSelected
            }"
            (click)="filter.onChangeLimitPaginationBlock(count)"
          >
            {{ count }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
